<script>
export default {
  mixins: [],

  props: {},

  data() {
    return {
      supplier: {
        id:0,
        name: "",
        sname:"",
        kana:"",
        systemCd:"",
        areaCd: "",
        area: "",
        tel: "",        
        fax: "",
        address1: "",
        address2: "",
        address3: "",
        president: "",
        url: "https://aaaa.bbbb.co.jp",
        capital: 0,
        mySales: 0,
        totalSales: 0,
        salesShare:null,
        employeeNum: 0,        
        equipments:[],
        itemGroups:[],
        mainPhotoId: null,
        updateUserId:"",
        updateUserName:"",
        applications:[],
        representatives: [
          {
            name: "",
            keyPerson: 0,
            tel: "",
            email: ""
          }
        ],
        subSuppliers: [],
        clients: [],
        contractors: [],
        priority: "",
        remarks:"",
        processGroups: [
          {
            processGroupCd: "",
            processGroupName: "",
            availableSizes: [
              {
                sizeItemCd: "",
                sizeItemName: "",
                unit: "",
                useRange: false,
                value1: null,
                value2: null,
              }
            ],
            materials: [
              {
                materialCd: "",
                materialName: ""
              }
            ],            
            processes:[
              {
                processCd:"",                
                processName:"",
              }
            ],
            tags: [
              ""
            ],

            materialFaces: [
              {                
                materialFaceCd: "",
                materialFaceName: ""
              }
            ],
            
          }
        ],

        score: {},

        images: [
          {file_id: 0, category: "", remarks: ""}
        ],

        imageMap: {
          cat1: [],
          cat2: [],
          cat3: [],
        },
        createAt:null,
        updateAt:null,
      },
    };
  },
  computed: {
      processingGroups() {
        return this.$store.state.processings.groupMap;
      },
      equipments() {
        return this.$store.state.equipments;
      },
      itemGroups() {
        return this.$store.state.itemGroups;
      },
      sizeItems() {
        return this.$store.state.sizeItems;
      },
      sizeItemMap() {
        return this.$store.state.sizeItemMap;
      },
      staffMap() {
        return this.$store.state.staffMap;
      },
      userId() {
        return this.$store.state.userProfile.userId
      },
  },
  methods: {

    // 新規仕入先用のデータをセットアップ
    makeNewData() {

      this.supplier = {
        id:0,
        name: "",
        sname:"",
        kana:"",
        systemCd:"",
        areaCd: "",
        areaName: "",
        tel: "",        
        fax: "",
        address1: "",
        address2: "",
        address3: "",
        president: "",
        url: "",
        capital: 0,
        mySales: 0,
        totalSales: 0,
        salesShare:null,
        employeeNum: 0,        
        equipments:[],
        itemGroups:[],
        mainPhotoId: null,
        updateUserId:"",
        updateUserName:"",
        applications:[],
        representatives: [],
        subSuppliers: [],
        clients: [],
        contractors: [],
        priority: "",
        remarks:"",
        processGroups: [],
        score: {},
        images: [          
        ],
        imageMap: {
          cat1: [],
          cat2: [],
          cat3: [],
        },
        createAt:null,
        updateAt:null,         
      };

    },


    makeDisplayData(data) {

      console.log("makeDisplayData",data);
      
      let apps = data.applications;
      let representatives = data.representatives;
      let mainClients = data.clients;
      let subSuppliers = data.subSuppliers;
      let contractors = data.contractors;
      let processGroups = data.processGroups;
      let images = data.images;
      let equipments = data.equipments;
      let item_groups = data.itemGroups;


      this.supplier.name = data.name;
      this.supplier.systemCd = data.systemCd;
      this.supplier.areaCd = data.areaCd;
      this.supplier.areaName = "";      
      this.supplier.tel = data.tel;
      this.supplier.fax = data.fax;
      this.supplier.address1 = data.address1;
      this.supplier.address2 = data.address2;
      this.supplier.address3 = data.address3;
      this.supplier.president = data.president;
      this.supplier.url = data.url;
      this.supplier.capital = data.capital;
      this.supplier.employeeNum = data.employeeNum;
      this.supplier.priority = data.priority;
      this.supplier.mainPhotoId = data.mainPhotoId;
      this.supplier.totalSales = data.totalSales;
      this.supplier.mySales = data.mySales;     
      this.supplier.updateUserId = data.updateUserId;
      this.supplier.updateUserName = data.updateUserName;
      this.supplier.createAt = data.createAt;
      this.supplier.updateAt = data.updateAt;

      this.supplier.applications.splice(0);
      Array.prototype.push.apply(this.supplier.applications, apps.map(a => a.applicationCd))

      this.supplier.contractors.splice(0);
      Array.prototype.push.apply(this.supplier.contractors, contractors.map(a => a.contractorCd))

      this.supplier.equipments.splice(0);
      Array.prototype.push.apply(this.supplier.equipments, equipments.map(a => a.equipmentCd))

      this.supplier.itemGroups.splice(0);
      Array.prototype.push.apply(this.supplier.itemGroups, item_groups.map(a => a.itemGroupCd))




      // 担当者
      this.supplier.representatives.splice(0);
      this.supplier.representatives = representatives.map(a => {
        return {
          name: a.name,
          keyPerson: a.keyPerson,
          tel: a.tel,
          email: a.email
        }
      });


      // 主要顧客
      this.supplier.clients.splice(0);
      Array.prototype.push.apply(this.supplier.clients, mainClients.map(a => {
        return {    
          company_cd: a.companyCd,
          name: a.name,          
          remark: a.remark
        }
      }))


      // 仕入先
      this.supplier.subSuppliers.splice(0);
      Array.prototype.push.apply(this.supplier.subSuppliers, subSuppliers.map(a => {
        return {
          name: a.name,
          remark: a.remark
        }
      }))


      // 工程グループ
      this.supplier.processGroups.splice(0);
      let procGroupList = processGroups.map(processGroup => {

        let processGroupCd = processGroup.processGroupCd;
        let processGroupName = processGroup.processGroupName;
        

        // 工程のリスト
        let processes = processGroup.processes.map(proc => {          
          return {
            processCd:proc.processCd,            
            processName:proc.processName,   
          };
        });


        let availableSizes = processGroup.availableSizes;
        //let availableSizeMap = {};
        //availableSizes.forEach(e => {
        //  availableSizeMap[e.sizeItemCd] = e
        //})


        let pGroup = this.processingGroups[processGroupCd]; // 工程のマスタ
        //console.log("this.processingGroups",this.processingGroups);
        //console.log("pGroup",pGroup);
        //let processSizeItems = pGroup.processSizeItems      // 工程マスタ上のサイズ設定

        let tags = processGroup.tags;

        let mat = processGroup.materials.map(psm => {
          return {            
            materialCd: psm.materialCd,
            materialName: psm.materialName
          }
        })

        let faces = processGroup.materialFaces.map(fcs => {
          return {            
            materialFaceCd: fcs.materialFaceCd,
            materialFaceName: fcs.materialFaceName
          }
        })

        let sizeSet = [];
        if (availableSizes) {
          sizeSet = availableSizes.map(asi => {
            let sizeRec = {
              itemCd: asi.sizeItemCd,
              name: asi.sizeItemName,
              unit: asi.unit,
              useRange: asi.useRange,
              value1: asi.size1,
              value2: asi.size2,
            };
            return sizeRec;
          });
        }
          

        return {
          processGroupCd: processGroupCd,
          processGroupName: processGroupName,
          processes:processes,
          tags: tags,
          materials: mat,
          materialFaces: faces,
          availableSizes: sizeSet,
        };
      }); // -- end of map processGroups

      Array.prototype.push.apply(this.supplier.processGroups, procGroupList)

      // images
      this.supplier.images.splice(0);
      Array.prototype.push.apply(this.supplier.images, images.map(a => {
        return {
          fileId: a.fileId,       
          category: a.category,
          remarks: a.remarks,
          uploadUserId: a.uploadUserId,
          uploadDate: a.uploadDate
        }
      }))

      //this.supplier.sales_share = (basic.my_sales / basic.total_sales) * 100.0;

      this.makeImageMap();

    },

    makeImageMap() {

      this.supplier.imageMap.cat1.splice(0);
      this.supplier.imageMap.cat2.splice(0);
      this.supplier.imageMap.cat3.splice(0);

      this.supplier.images.forEach(a => {
        if (a.category == "1") {
          this.supplier.imageMap.cat1.push(a)
        } else if (a.category == "2") {
          this.supplier.imageMap.cat2.push(a)
        } else if (a.category == "3") {
          this.supplier.imageMap.cat3.push(a)
        }
      })

    },


  },

}
</script>
